// extracted by mini-css-extract-plugin
module.exports = {"container":"Visits_container__1Ut_v","list":"Visits_list__2pFCO","row":"Visits_row__1P-Ra","col":"Visits_col__2IGSB","slide-left":"Visits_slide-left__SB_2c"};